import axiosIns from '@/api/axios';


// Structured Learning
export const GET_IDP_PERSONAL = (args) => {
    return axiosIns.get('/idp-new', args)
}
export const GET_MY_IDP_STRUCTURED = (params) => {
    return axiosIns.get('/idp/structured-learning', { params });
}
export const GET_MY_IDP_SOCIAL = (params) => {
    return axiosIns.get('/idp/social-learning', { params })
}
export const GET_MY_IDP_EXPERIENTIAL = (params) => {
    return axiosIns.get('/idp/experential-learning', { params })
}
export const GET_IDP_MANAGER = (args) => {
    return axiosIns.get('/idp-manager-new', args)
}
export const GET_IDP_HR_STRUCTURED = (args) => {
    return axiosIns.get('/idp/approved-structured-learning', args)
}
export const GET_IDP_HR_SOCIAL = (args) => {
    return axiosIns.get('/idp/approved-social-learning', args)
}
export const GET_COACHING = (params) => {
    return axiosIns.get('/master-data/coaching', { params })
}
export const GET_COACHING_DETAIL = (id) => {
    return axiosIns.get(`/master-data/coaching/${id}`)
}
export const INIT_IDP_STRUCTURED_LEARNING = (args) => {
    return axiosIns.get('/idp/init-structured-learning', args)
}
export const CREATE_STRUCTURED_LEARNING = (args) => {
    return axiosIns.post('/idp/create-structured-learning', args)
}
export const CREATE_SOCIAL_LEARNING = (args) => {
    return axiosIns.post('/idp/create-social-learning', args)
}
export const ENROLLED_STRUCTURED_LEARNING = (args) => {
    return axiosIns.post('/idp/enrolled-structured-learning', args)
}
export const SUBMIT_STRUCTURED_LEARNING = (args) => {
    return axiosIns.post('/idp/submit-structured-learning', args)
}
export const APPROVE_STRUCTURED_LEARNING = (args) => {
    return axiosIns.post('/idp/approved-structured-learning', args)
}
export const UPLOAD_CERTIFICATE_STRUCTURED_LEARNING = (args, id) => {
    return axiosIns.post(`/idp/upload-structured-learning/${id}`, args, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}
export const UPLOAD_PRESENTATION_SOCIAL_LEARNING = (args, id) => {
    return axiosIns.post(`/idp/upload-social-learning/${id}`, args, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}
export const DOWNLOAD_CERTIFICATE_STRUCTURED_LEARNING = (args) => {
    return axiosIns.get(`/idp/download-structured-learning/${args.name}`)
}
export const UPDATE_SCORE_STRUCTURED_LEARNING = (args) => {
    return axiosIns.put(`/idp/score-structured-learning/${args.id}`, {
        score: args.score,
        feedback: args.feedback
    })
}
export const UPDATE_SCORE_SOCIAL_LEARNING = (args) => {
    return axiosIns.put(`/idp/score-social-learning/${args.id}`, {
        score: args.score,
        feedback: args.feedback
    })
}

// Social Learning
export const INIT_IDP_SOCIAL_LEARNING = (args) => {
    return axiosIns.get('/idp/init-social-learning', args)
}
export const SUBMIT_SOCIAL_LEARNING = (args) => {
    return axiosIns.post('/idp/submit-social-learning', args)
}
export const APPROVE_SOCIAL_LEARNING = (args) => {
    return axiosIns.post('/idp/approved-social-learning', args)
}
export const ENROLLED_SOCIAL_LEARNING = (args) => {
    return axiosIns.post('/idp/enrolled-social-learning', args)
}
// Project
export const CREATE_PROJECT = (formData) => {
    return axiosIns.post('/idp/project', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}
export const SUBMIT_SUMMARY = (formData) => {
    return axiosIns.post('/idp/coaching-summary', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const CREATE_PROJECT_ACTIVITIES = (args) => {
    return axiosIns.post('/idp/project-activities', args)
}
// export const EDIT_PROJECT_ACTIVITIES = (args) => {
//     return axiosIns.put(`/idp/project-activities/${args.id}`, args)
// }
// export const DELETE_PROJECT_ACTIVITIES = (args) => {
//     return axiosIns.delete(`/idp/project-activities/${args.id}`, args)
// }

export const EDIT_PROJECT_ACTIVITIES = (id, formData) => {
    return axiosIns.put(`/idp/project-activities/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}
export const UPDATE_PROJECT_STATUS = (id, status, notes) => {
    return axiosIns.post(`/idp/project/${id}/${status}`, { notes });
}

export const DELETE_PROJECT_ACTIVITIES = (id) => {
    return axiosIns.delete(`/idp/project-activities/${id}`)
}
export const COMPLETE_PROJECT_ACTIVITIES = (id) => {
    return axiosIns.put(`/idp/project-activities/${id}/completed`)
}
export const CREATE_COACHING_SCHEDULE = (id, args) => {
    return axiosIns.post(`/idp/coaching/${id}/schedule`, args)
}
export const GET_SOCIAL_BY_ID = (id) => {
    return axiosIns.get(`/idp/social-learning/${id}`)
}
export const ASSIGN_PROJECT = (args) => {
    return axiosIns.post('/idp/assign-project', args)
}
export const CREATE_COACHING = (args) => {
    // If args is FormData, let axios set Content-Type automatically
    const config = args instanceof FormData ? {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    } : {};

    return axiosIns.post('/master-data/coaching', args, config)
}

export const DELETE_COACHING = (id) => {
    return axiosIns.delete(`/master-data/coaching/${id}`)
}

export const UPDATE_COACHING = (id, args) => {
    // If args is FormData, let axios set Content-Type automatically
    const config = args instanceof FormData ? {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    } : {};

    return axiosIns.put(`/master-data/coaching/${id}`, args, config)
}

export const GET_PROJECT_USER = (id, args) => {
    const params = queryString.stringify(args);
    return axiosIns.get(`/idp/experential-learning/${id}?${params}`);
}
export const GET_PROJECT_USER_BY_NIK = (nik, args) => {
    const params = queryString.stringify(args);
    return axiosIns.get(`/idp/project-user/${nik}?${params}`);
}
export const GET_TRAINING_EVENT_HR = (id, args) => {
    const params = queryString.stringify(args);
    return axiosIns.get(`/idp/training-event/${id}/hr`);
}
export const GET_TRAINING_EVENT_EMP = (id) => {
    return axiosIns.get(`/idp/training-event/${id}`);
}
export const CREATE_TRAINING_EVENT = (args) => {
    return axiosIns.post('/idp/training-event', args)
}
export const EDIT_TRAINING_EVENT = (args) => {
    return axiosIns.put(`/idp/training-event/${args.id}`, args)
}
export const DELETE_TRAINING_EVENT = (id) => {
    return axiosIns.delete(`/idp/training-event/${id}`)
}
export const ENROLL_TRAINING_EVENT = (args) => {
    return axiosIns.post('/idp/enroll-training-event', args)
}

export const GET_IN_REVIEW = (args) => {
    return axiosIns.get(`/idp/review-structured-learning?${args}`, args)
}
export const GET_IN_REVIEW_SOCIAL = (args) => {
    return axiosIns.get('/idp/review-social-learning', args)
}
export const COMPLETE_REVIEW = (id) => {
    return axiosIns.post(`/idp/completed-structured-learning/${id}`)
}
export const BULK_APPROVED = (args) => {
    return axiosIns.post(`/idp/completed-structured-learning`, args)
}
export const BULK_APPROVED_SOCIAL = (args) => {
    return axiosIns.post(`/idp/completed-social-learning`, args)
}
export const BULK_APPROVED_LND = (args) => {
    return axiosIns.post(`/idp-examination/approved`, args)
}
export const COMPLETE_REVIEW_SOCIAL = (args) => {
    return axiosIns.post(`/idp/completed-social-learning`, args)
}
export const ADD_FEEDBACK_EXAMINATION = (args) => {
    return axiosIns.put(`/idp-examination/${args.id}/feedback`, { feedback: args.feedback });
}
export const ADD_FEEDBACK_ACTIVITIES = (args) => {
    return axiosIns.post('/idp/project-activities/feedback', args)
}
export const ADD_FEEDBACK_COACHING = (args) => {
    return axiosIns.post('/idp/coaching-feedback', args)
}
export const ADD_PROGRESS_ACTIVITY = (args) => {
    return axiosIns.post('/idp/project-activities/progress', args)
}

export const CREATE_PROPOSSED = (args) => {
    return axiosIns.post('/idp/propossed-time', args)
}

